import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    overlappingTags: translate({ id: 'order.form.bulk.errors.tag.overlapping' }),
    loads: translate({ id: 'orders.edit.field.loads' }),
    addLoad: translate({ id: 'order.form.bulk.loads.addLoadsModalTitle' }),
    waringCardTitle: translate({ id: 'order.form.bulk.loads.warningCard.title' }),
    waringCardText: translate({ id: 'order.form.bulk.loads.warningCard.text' }),

    invalidLoadInvalidFormat: translate({ id: 'order.form.bulk.errors.load.invalid.notANumber' }),
    invalidLoadLessThanZero: translate({ id: 'order.form.bulk.errors.load.invalid.lessThanZero' }),
    invalidLoadExceedMaxValue: translate({
      id: 'order.form.bulk.errors.load.invalid.exceedMaxValue',
      values: { max: '5 000 000' },
    }),
    invalidLoadExceedMaxCharacters: translate({
      id: 'order.form.bulk.errors.load.invalid.exceedMaxCharacters',
    }),
    invalidLoadsError: translate({
      id: 'orders.edit.validation.loads',
    }),
    invalidValue: translate({ id: 'components.loadList.loads.noValidValue' }),
    invalidName: translate({ id: 'components.loadList.loads.noValidName' }),
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
